export const getSnackbar = state =>
    Object.keys(state.snackbar).length ? state.snackbar : undefined;



// WEBPACK FOOTER //
// ./src/selectors/snackbarSelectors.js